import { useEffect, useState } from "react";
import { OrderTransport } from "src/app/transports/order";

const useGetJarvisPromptForAiGuide = ({
    orderId,
    intentSearch,
    title,
    plan,
    text,
    initialRequest = true,
}: {
    orderId: number;
    intentSearch?: string | null;
    title?: string | null;
    plan?: string | null;
    text?: string | null;
    initialRequest?: boolean;
    metaTitle?: string | null;
    metaDescription?: string | null;
}) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const [intentSearchSuggest, setIntentSearchSuggest] = useState<string | null>(null);
    const [titleSuggest, setTitleSuggest] = useState<string | null>(null);
    const [planSuggest, setPlanSuggest] = useState<string | null>(null);
    const [metaTitleSuggest, setMetaTitleSuggest] = useState<string | null>("");
    const [metaDescriptionSuggest, setMetaDescriptionSuggest] = useState<string | null>("");
    const [textSuggest, setTextSuggest] = useState<string | null>("");

    const fetch = (urlParam: "INTENT_SEARCH" | "TITLE" | "PLAN" | "META" | "TEXT" | "IMAGE") => {
        setLoading(true);
        OrderTransport.aiManualGuidePrompts(
            orderId,
            urlParam,
            intentSearch ?? undefined,
            title ?? undefined,
            plan ?? undefined,
            text ?? undefined
        )
            .then((res) => {
                switch (urlParam) {
                    case "INTENT_SEARCH":
                        setIntentSearchSuggest(res);
                        break;
                    case "TITLE":
                        setTitleSuggest(res);
                        break;
                    case "PLAN":
                        setPlanSuggest(res);
                        break;
                    case "META":
                        setMetaTitleSuggest(res);
                        setMetaDescriptionSuggest(res);
                        break;
                    case "TEXT":
                        setTextSuggest(res);
                        break;
                }
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const refresh = (urlParam: "INTENT_SEARCH" | "TITLE" | "PLAN" | "META" | "TEXT" | "IMAGE") => {
        if (!orderId) return;
        if (!loading) fetch(urlParam);
    };

    useEffect(() => {
        if (initialRequest) fetch("INTENT_SEARCH");
    }, []);

    return {
        intentSearchSuggest,
        titleSuggest,
        planSuggest,
        metaTitleSuggest,
        metaDescriptionSuggest,
        textSuggest,
        refresh,
        error,
        loading,
    };
};

export default useGetJarvisPromptForAiGuide;
